import { theme } from '../../styles/theme';

export const signInMobileHeader = {
  fontWeight: 800,
  fontSize: '40px',
  lineHeight: '50px',
  letterSpacing: '-2px',
  textAlign: 'center',
  color: theme.palette.common.darkGrey6,
  display: { desktop: 'none' },
  marginBottom: '24px'
};

export const signInError = {
  width: '50%',
  position: 'unset'
};

export const signInResetPasswordLink = {
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 600,
  marginLeft: 'auto',
  color: theme.palette.common.textInteractiveBrand
};

export const signInAndText = {
  fontSize: '14px',
  fontWeight: '600',
  color: theme.palette.common.darkGrey2
};

export const SignInAlreadyHaveAnAccountHeader = {
  fontSize: {
    tablet: '32px',
    mobile: '22px'
  },
  fontWeight: 800,
  textAlign: 'center',
  width: '80%',
  margin: '0 auto',
  marginTop: '16px'
};

export const SignInAlreadyHaveAnAccountImage = {
  margin: '0 auto',
  marginTop: '24px',
  marginBottom: '24px',
  display: 'block'
};

export const SignInAlreadyHaveAnAccountEmail = {
  fontSize: '16px',
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: '24px'
};

export const SignInConsentLink = {
  cursor: 'pointer',
  textDecoration: 'underline',
  color: theme.palette.common.darkGrey2,
  fontWeight: 600
};

export const ErrorLinkStyle = {
  fontWeight: 700,
  textDecoration: 'underline',
  color: theme.palette.common.darkRed,
  cursor: 'pointer'
};

export const signInDivider = {
  borderTop: `1px solid ${theme.palette.common.lightGrey14}`,
  marginTop: '24px',
  minWidth: '248px'
};
